<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100 h-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-input-group class="mb-2">
        <b-form-input
          name="password"
          v-model="$v.form.password.$model"
          :state="validateState('password')"
          :type="isPasswordDisplayed"
          placeholder="Password"
          size="sm"
          class="mb-0"
        >
        </b-form-input>
        <b-input-group-append>
          <span class="input-group-text small spnod-cursor" @click="handlePassToggle('password')">
            <i v-if="!showPassword" class="fa fa-eye fa-sm"></i>
            <i v-else class="fa fa-eye-slash fa-sm"></i>
          </span>
        </b-input-group-append>
        <b-form-invalid-feedback>
          Password must be at least 8 characters long and contain at least 1 capital letter, 1 number and 1 symbol
        </b-form-invalid-feedback>
      </b-input-group>
      <b-input-group class="mb-4">
        <b-form-input
          name="password2"
          v-model="$v.form.password2.$model"
          :state="validateState('password2')"
          :type="isConfirmDisplayed"
          placeholder="Confirm Password"
          size="sm"
          class="mb-0"
        >
        </b-form-input>
        <b-input-group-append>
          <span class="input-group-text small spnod-cursor" @click="handlePassToggle('confirm')">
            <i v-if="!showConfirm" class="fa fa-eye fa-sm"></i>
            <i v-else class="fa fa-eye-slash fa-sm"></i>
          </span>
        </b-input-group-append>
        <b-form-invalid-feedback>
          Must match password
        </b-form-invalid-feedback>
      </b-input-group>
        <ul class="spnod-admin__form--list">
          <li>
            <router-link id="login" class="spnod-admin__form--link" to="/login">Login</router-link>
          </li>
        </ul>
        <ul v-if="resetPasswordErrors.length > 0" class="spnod-text--error spnod-text--center">
          <li v-for="error in resetPasswordErrors" class="spnod-list__item">
            {{error}}
          </li>
        </ul>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
          <p v-if="!isSending">Send</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'ResetPasswordForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        password: '',
        password2: '',
        code: ''
      },
      resetPasswordErrors: [],
      showPassword: false,
      showConfirm: false,
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['passwordReset', 'getMyInfo']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some(arr => arr[1] === '')
      return anyBlanks || this.$v.form.$anyError
    },
    isPasswordDisplayed() {
      return this.showPassword ? 'text' : 'password'
    },
    isConfirmDisplayed() {
      return this.showConfirm ? 'text' : 'password'
    },
    isMobile() { return window.innerWidth <= 768 }
  },
  methods: {
    ...mapActions([
      'doResetPassword',
      'getErrors'
    ]),
    async handleSubmit() {
      try {
        this.isSending = true
        await this.doResetPassword(this.form)
        this.isSending = false
      } catch (err) {
        console.log(err)
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handlePassToggle(type) {
      if (type === 'password') {
        this.showPassword = !this.showPassword
      } else {
        this.showConfirm = !this.showConfirm
      }
    }
  },
  beforeCreate () {
    this.$store.commit('RESETPASSWORDFIELDSET')
  },
  created () {
    const code = this.$route.query.code || ''
    // if it's not an email address, it's probably our code so set it
    if (!/^[aA-zZ0-9._%+-]+@[aA-zZ0-9.-]+\.[aA-zZ]{2,}$/.test(code)) {
      this.form.code = this.$route.query.code || ''
    }
  },
  mounted () {
    this.subscriptions = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'RESETPASSWORDERROR':
          this.$store.dispatch('checkNested', { obj: mutation, props: ['payload', 'message'] }).then((res) => {
            if (res === false) {
              return false
            }
            this.resetPasswordErrors = [mutation.payload.message]
          })
          this.$store.dispatch('checkNested', { obj: mutation, props: ['payload', 'msg'] }).then((res) => {
            if (res === false) {
              return false
            }
            this.resetPasswordErrors = [mutation.payload.msg]
          })
          break
      }
    })
  },
  beforeDestroy () {
    this.subscriptions()
  },
  validations: {
    form: {
      password: { required, regex: (pass) => /^(?=.*[A-Z])(?=.*[^aA-zZ0-9])(?=.*[0-9]).{6,}$/.test(pass) },
      password2: { required, samePassword: sameAs('password') },
      code: { required }
    }
  },
  watch: {
    passwordReset: function (newVal, oldVal) {
      if (newVal === true) {
        this.$router.push('/messages')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/ResetPasswordForm.vue?3133f0a7